<template>
    <div
        style="max-height: 300px"
        class="overflow-y-auto overflow-x-hidden">
        <p
            v-for="(item, index) in data"
            :key="index">
            {{ item }} <br v-if="index < data.length - 1" >
        </p>
    </div>
</template>
<script lang="ts" setup>
const store = $store()
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref([])

onBeforeMount(() => {
  try {
    const businessIds = Object.keys(params?.value?.data.businesses)
    const businesses = store.data.getBusinesses
    data.value = businesses.filter((business: any) => businessIds?.includes(business._id)).map((business: any) => business.name)
  } catch (e) {
    data.value = []
  }
})
</script>
